<template>
  <!-- 运费支付 -->
  <div>
    <div class="searchBox" ref="searchBox">
      <el-form
        :inline="true"
        ref=""
        class="demo-form-inline"
        label-width="110px"
        size="mini"
      >
        <div style="display:flex">
          <div class="gjhBox">
            <el-form-item label="业务编号:" prop="businessNo">
              <el-input
                placeholder=""
                type="textarea"
                v-model="searchFrom.businessNoss"
                class="gjh"
              ></el-input>
            </el-form-item>
          </div>
          <div style="display: flex;flex-wrap: wrap;">
            <el-form-item label="付款状态:" prop="settlementStatus">
              <el-select
                v-model="searchFrom.settlementStatus"
                placeholder="请选择"
              >
                <el-option label="待付款" value="1301"></el-option>
                <el-option label="已付款待确认" value="1302"></el-option>
                <el-option label="已付款" value="1303"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="业务类型" prop="invoiceType">
              <el-select v-model="searchFrom.invoiceType" placeholder="请选择">
                <el-option label="请选择" value=""></el-option>
                <el-option label="运输业务" value="1"></el-option>
                <el-option label="快递业务" value="2"></el-option>
                <el-option label="找车业务" value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="签收人:" prop="createUserName">
              <el-input
                placeholder=""
                v-model="searchFrom.createUserName"
              ></el-input>
            </el-form-item>
            <el-form-item label="发布部门:" prop="orgName">
              <el-input placeholder="" v-model="searchFrom.orgName"></el-input>
            </el-form-item>
            <el-form-item label="承运方:" prop="carrierName">
              <el-input
                placeholder=""
                v-model="searchFrom.carrierName"
              ></el-input>
            </el-form-item>
            <el-form-item label="车牌号:" prop="vhcNo">
              <el-input placeholder="" v-model="searchFrom.vhcNo"></el-input>
            </el-form-item>
            <el-form-item label="收货单位:" prop="receivingCompany">
              <el-input
                placeholder=""
                v-model="searchFrom.receivingCompany"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="平台收款账户名称:"
              label-width="130px"
              prop="platformZxAccNm"
            >
              <el-input
                placeholder=""
                v-model="searchFrom.platformZxAccNm"
              ></el-input>
            </el-form-item>
            <el-form-item label="付款时间:" prop="settlementTimes">
              <el-date-picker
                v-model="searchFrom.settlementTimes"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="付款客户 :" prop="payCustomerName">
              <el-select
                v-model="searchFrom.payCustomerName"
                filterable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in customTypes"
                  :label="item.value1"
                  :value="item.value1"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="结算量:" prop="weight" class="fanwei">
                  <el-input  placeholder="" v-number-input.float="3"  v-model="searchFrom.weightStart"></el-input>-
                  <el-input  placeholder="" v-number-input.float="3"  v-model="searchFrom.weightEnd"></el-input>
                </el-form-item>
                <el-form-item label="应付合计:" prop="weight" class="fanwei">
                  <el-input  placeholder="" v-number-input.float="2"  v-model="searchFrom.totalAmountStart"></el-input>-
                  <el-input  placeholder="" v-number-input.float="2"  v-model="searchFrom.totalAmountEnd"></el-input>
                </el-form-item> -->
          </div>
        </div>
        <div class="searchBtnBox">
          <el-form-item btnCode="00JP009B001" v-if="btnFlg[0]">
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="resetForm('searchFrom')"
              >重置</el-button
            >
          </el-form-item>
          <el-form-item btnCode="00JP009B003" v-if="btnFlg[2]">
            <el-button type="primary" @click="fukuanFn">付款</el-button>
          </el-form-item>
          <el-form-item btnCode="00JP009B004" v-if="btnFlg[3]">
            <el-button type="primary" @click="exportFn" :disabled="isDisable"
              >导出</el-button
            >
          </el-form-item>
          <el-form-item>
            <div style="display:flex;">
              <p
                style="width:15px;height:15px;background:#F2E0D7;margin-top: 6px;"
              ></p>
              <span class="red">超期未结算</span>
            </div>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{ height: h }">
      <el-table
        :data="tableList"
        :cell-class-name="myclass"
        ref="table"
        v-loading="loading"
        bordersize="mini"
        @selection-change="selectGoods"
        height="100%"
        style="width: 100%"
        center
        border
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          type="index"
          fixed
          prop="date"
          width="55"
          label="序号"
        ></el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <div>
              <el-button
                type="text"
                size="mini"
                v-if="scope.row.settlementStatus == 1303"
                @click="huidanFn(scope.row)"
                >银行回单</el-button
              >
              <el-button
                type="text"
                size="mini"
                v-if="scope.row.settlementStatus == 1301 && btnFlg[4]"
                @click="xianxiaFn(scope.row)"
                >线下支付</el-button
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column label="业务编号" width="200">
          <template slot-scope="scope">
            <span
              style="color: #0e6eec;cursor: pointer;"
              v-if="scope.row.invoiceType == 1"
              @click="seeClickNO(scope.row)"
              >{{ scope.row.businessNo }}</span
            >
            <span v-else>{{ scope.row.businessNo }}</span>
          </template>
        </el-table-column>
        <el-table-column
          property="settlementStatus"
          label="付款状态"
          width="100"
        >
          <template scope="scope">
            <div>
              <span v-if="scope.row.settlementStatus == 1301" style="color:red"
                >待付款</span
              >
              <span v-if="scope.row.settlementStatus == 1302"
                >已付款待确认</span
              >
              <span v-if="scope.row.settlementStatus == 1303">已付款</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="payType" label="支付方式">
          <template scope="scope">{{
            ['线上支付', '线下支付'][scope.row.payType - 1]
          }}</template>
        </el-table-column>
        <el-table-column property="invoiceType" label="业务类型" width="100">
          <template scope="scope">{{
            ['运输业务', '快递业务', '找车业务'][scope.row.invoiceType - 1]
          }}</template>
        </el-table-column>
        <el-table-column
          property="weight"
          width="100"
          :formatter="emptyFn"
          label="承运方类型"
        >
          <template scope="scope">
            <div>
              <span v-if="scope.row.invoiceType == 1">{{
                ['平台', '车队', '司机', '车队长'][scope.row.settlementType]
              }}</span>
              <span v-if="scope.row.invoiceType != 1">-</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          property="carrierName"
          width="100"
          :formatter="emptyFn"
          label="承运方"
        >
          <template scope="scope">
            <div>
              <span v-if="scope.row.invoiceType != 1">-</span>
              <span v-else>{{
                scope.row.carrierName ? scope.row.carrierName : '-'
              }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="150"
          property="vhcNo"
          :formatter="emptyFn"
          label="车牌号"
        ></el-table-column>
        <el-table-column
          width="170"
          property="outTime"
          :formatter="dateTimeFormat"
          label="装车时间"
        ></el-table-column>
        <el-table-column
          width="200"
          property="receivingCompany"
          :formatter="emptyFn"
          label="收货单位"
        ></el-table-column>
        <el-table-column
          property="payCustomerName"
          width="240"
          :formatter="emptyFn"
          label="付款客户"
        ></el-table-column>
        <el-table-column
          property="payCustomerReceiveAmount"
          width="110"
          :formatter="emptyFn"
          label="收款金额"
        ></el-table-column>
        <el-table-column
          property="weight"
          width="110"
          :formatter="emptyFn"
          label="结算量"
        >
          <template scope="scope">
            <span>{{ scope.row.weight + scope.row.unitMeasurement }}</span>
          </template>
        </el-table-column>
        <el-table-column property="publishPricingMethod" label="计价方式">
          <template scope="scope">
            <div>
              <span>{{ ['单价', '包干'][scope.row.pricingMethod - 1] }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="unitPrice" width="100" label="单价">
          <template scope="scope">
            <div>
              <span v-if="scope.row.pricingMethod == 1"
                >{{ scope.row.unitPrice }}元/{{
                  scope.row.unitMeasurement
                }}</span
              >
              <span v-if="scope.row.pricingMethod == 2">-</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          property="rate"
          label="服务费率"
          width="100"
          :formatter="emptyFn"
        >
          <template scope="scope">
            <div>
              <span v-if="scope.row.invoiceType != 1">-</span>
              <span v-else>{{ scope.row.rate }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="应付合计(元)" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.invoiceType == 3">{{
              scope.row.totalAmount
            }}</span>
            <span
              v-else
              style="color: #0e6eec;cursor: pointer;"
              @click="YFHJfn(scope.row)"
              >{{ scope.row.totalAmount }}</span
            >
          </template>
        </el-table-column>

        <el-table-column property="settlementStatus" label="调价" width="120">
          <template scope="scope">
            <div>
              <el-button
                type="text"
                size="mini"
                @click="tiaojiaFn(scope.row)"
                v-if="
                  scope.row.settlementStatus == 1301 &&
                    scope.row.invoiceType == 1
                "
                >调价</el-button
              >
              <!-- <el-button type="text" size="mini"  @click="tiaojiaFn(scope.row)" v-if="scope.row.settlementStatus==1301&&scope.row.isPrice==2">调价</el-button> -->
              <!-- <el-button type="text" size="mini" v-if="scope.row.isPrice==1" @click="jiluFn(scope.row)">记录</el-button> -->
              <el-button
                type="text"
                size="mini"
                v-if="scope.row.isPrice == 1"
                @click="jiluFn(scope.row)"
                >记录</el-button
              >
              <span
                v-if="
                  scope.row.settlementStatus != 1301 && scope.row.isPrice != 1
                "
                >-</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="200"
          property="platformZxAccNo"
          :formatter="emptyFn"
          label="平台收款账号"
        ></el-table-column>
        <el-table-column
          width="320"
          property="platformZxAccNm"
          :formatter="emptyFn"
          label="平台收款账户名称"
        ></el-table-column>
        <el-table-column
          property="createUserName"
          width="120"
          :formatter="emptyFn"
          label="签收人"
        >
          <template scope="scope">
            <div>
              <span v-if="scope.row.invoiceType == 2">-</span>
              <span v-else>{{ scope.row.createUserName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          property="orgName"
          width="180"
          :formatter="emptyFn"
          label="发布部门"
        >
          <template scope="scope">
            <div>
              <span v-if="scope.row.invoiceType == 2">-</span>
              <span v-else>{{ scope.row.orgName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="170"
          property="settlementTime"
          :formatter="dateTimeFormat"
          label="付款时间"
        ></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[10, 25, 50, 100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 付款 -->
    <el-dialog
      title="付款"
      :visible.sync="fukuanMark"
      width="600px"
      class="detail"
      :close-on-click-modal="false"
      @close="closeDialog"
      :close-on-press-escape="false"
      center
    >
      <el-form
        :inline="true"
        :model="fukuanFrom"
        ref="fukuanFrom"
        :rules="rules"
        class="demo-form-inline jiaoyan"
        label-width="100px"
        size="mini"
      >
        <div class="inpBox">
          <div style="display: flex;justify-content: space-between; ">
            <p>
              应付合计:<span style="color:red;font-size:18px">{{
                fukuanFrom.ext1
              }}</span
              >元
            </p>
            <p v-if="fukuanFrom.departmentMoney">
              部门金额:<span style="color:red;font-size:18px">{{
                fukuanFrom.departmentMoney
              }}</span
              >元
            </p>
            <p>
              储蓄金额:<span>{{ fukuanFrom.accountMoney }}</span
              >元
            </p>
          </div>
          <div
            style="text-align: center; margin: 28px 0;display:flex;flex-direction:column"
          >
            <el-form-item prop="password" label="支付密码:">
              <el-input
                v-model="fukuanFrom.password"
                maxlength="20"
                show-password
                placeholder="请输入密码"
              ></el-input>
            </el-form-item>
            <!-- <el-checkbox v-model="fukuanFrom.isUrgentPaymentZ">是否加急支付给承运人</el-checkbox> -->
            <div v-if="isUrgent == '0'" style="margin-left:58px;color:red;">
              加急支付给承运人
            </div>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="fukuanMark = false">取消</el-button>
        <el-button type="primary" @click="ZFsave()">支付</el-button>
      </span>
    </el-dialog>
    <!-- 应付合计 -->
    <el-dialog
      title="应收合计"
      :visible.sync="HJmark"
      width="600px"
      class="detail"
      :close-on-click-modal="false"
      @close="closeDialog"
      :close-on-press-escape="false"
      center
    >
      <div>
        <div class="addressBox">
          <div>
            <p>
              应付合计:<span style="color:red;font-size:18px">{{
                row.totalAmount
              }}</span
              >元
            </p>
          </div>
        </div>
        <div class="table">
          <el-table
            :data="hejiList"
            ref="hejiList"
            v-loading="loading"
            bordersize="mini"
            @selection-change="selectGoods"
            style="width: 100%"
            center
            border
          >
            <el-table-column property="publishPricingMethod" label="费目">
              <template scope="scope">{{
                ['运费', '服务费', '押金'][scope.row.feeType - 1]
              }}</template>
            </el-table-column>
            <el-table-column property="publishPricingMethod" label="状态">
              <template scope="scope">{{
                ['待付款', '已付款'][scope.row.feeStatus - 1]
              }}</template>
            </el-table-column>
            <el-table-column
              property="amount"
              width="120"
              :formatter="emptyFn"
              label="金额(元)"
            ></el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="HJmark = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 调价 -->
    <el-dialog
      title="调价"
      :visible.sync="tiaojiaMark"
      width="400px"
      class="detail"
      :close-on-click-modal="false"
      @close="closeDialog"
      :close-on-press-escape="false"
      center
    >
      <el-form
        :inline="true"
        :model="tiaojiaFrom"
        ref="tiaojiaFrom"
        :rules="rules"
        class="demo-form-inline jiaoyan"
        label-width="100px"
        size="mini"
      >
        <div class="inpBox">
          <el-form-item prop="weight" label="签收量:">
            <span>{{ tiaojiaFrom.weight }}</span>
          </el-form-item>
          <el-form-item label="计价方式 :" prop="pricingMethod" class="jiage">
            <el-select v-model="tiaojiaFrom.pricingMethod" placeholder="请选择">
              <el-option
                v-for="val in jjfangshi"
                :label="val.name"
                :value="val.val"
                :key="val.val"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="单价:"
            class="jiage"
            prop="unitPrice"
            v-if="tiaojiaFrom.pricingMethod == 1"
          >
            <el-input
              placeholder=""
              v-number-input.float="2"
              maxlength="8"
              v-model="tiaojiaFrom.unitPrice"
            ></el-input
            ><span class="danwei">元/{{ tiaojiaFrom.unitMeasurement }}</span>
          </el-form-item>
          <el-form-item
            label="包干价:"
            class="jiage"
            prop="unitPrice"
            v-if="tiaojiaFrom.pricingMethod == 2"
          >
            <el-input
              placeholder=""
              v-number-input.float="2"
              maxlength="8"
              v-model="tiaojiaFrom.unitPrice"
            ></el-input>
          </el-form-item>
          <el-form-item prop="rate" label="服务费率:">
            <div style="width:150px" v-if="tiaojiaFrom.rate">
              {{ accMul(tiaojiaFrom.rate, 100) }}%
            </div>
          </el-form-item>
          <el-form-item prop="taxation" label="服务费:">
            <div style="width:150px">{{ tiaojiaFrom.taxation }}元</div>
          </el-form-item>
          <el-form-item prop="totalAmount" label="应付运费:">
            <div style="width:150px">{{ tiaojiaFrom.fatePrice }}元</div>
          </el-form-item>
          <el-form-item prop="reason" label="调价原因:">
            <el-input
              type="textarea"
              :rows="4"
              placeholder=""
              maxlength="500"
              v-model="tiaojiaFrom.reason"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="tiaojiaMark = false">取消</el-button>
        <el-button type="primary" @click="TJsave()">确定</el-button>
      </span>
    </el-dialog>
    <!-- 调价记录 -->
    <el-dialog
      title="调价记录"
      :visible.sync="jiluMark"
      width="800"
      class="detail"
      :close-on-click-modal="false"
      @close="closeDialog"
      :close-on-press-escape="false"
      center
    >
      <div>
        <div v-for="item in jiluList" :key="item.id">
          <div class="table">
            <div style=" display: flex;justify-content: space-between;">
              <p style="font-size：18px;font-weight: bold;">调价前</p>
              <p>调价时间：{{ item.createTime | dateFormat }}</p>
            </div>
            <el-table
              :data="item.tableList"
              v-loading="loading"
              bordersize="mini"
              @selection-change="selectGoods"
              style="width: 100%"
              center
              border
            >
              <el-table-column
                type="index"
                fixed
                prop="date"
                width="55"
                label="序号"
              ></el-table-column>
              <el-table-column property="publishPricingMethod" label="计价方式">
                <template scope="scope">{{
                  ['单价', '包干'][scope.row.pricingMethod - 1]
                }}</template>
              </el-table-column>
              <el-table-column property="unitPrice" width="100" label="单价">
                <template scope="scope">
                  <div>
                    <span v-if="scope.row.pricingMethod == 1"
                      >{{ scope.row.unitPrice }}元/{{ unitMeasurement }}</span
                    >
                    <span v-if="scope.row.pricingMethod == 2">-</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="weight"
                label="结算量"
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.weight }}{{ unitMeasurement }}</span>
                </template>
              </el-table-column>
              <el-table-column
                property="actualFatePrice"
                width="120"
                :formatter="emptyFn"
                label="运费(元)"
              ></el-table-column>
              <el-table-column
                property="actualTaxation"
                width="120"
                :formatter="emptyFn"
                label="服务费(元)"
              ></el-table-column>
              <el-table-column
                property="actualTotalAmount"
                width="120"
                :formatter="emptyFn"
                label="应付合计(元)"
              ></el-table-column>
            </el-table>
          </div>
          <div
            style="border-bottom: 1px dashed #ddd; margin-top: 25px;"
            v-if="jiluList.length > 0"
          >
            <p>操作人员：{{ item.createUserName }}</p>
            <p>调价原因：{{ item.reason }}</p>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="jiluMark = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 支付状态 -->
    <el-dialog
      title="支付状态"
      :visible.sync="zfztMark"
      width="800"
      class="detail"
      :close-on-click-modal="false"
      @close="closeDialog"
      :close-on-press-escape="false"
      center
    >
      <div class="table">
        <el-table
          :data="zfztList"
          bordersize="mini"
          :row-class-name="tableRowClassName"
          style="width: 100%"
          center
          border
        >
          <el-table-column
            type="index"
            fixed
            prop="date"
            width="55"
            label="序号"
          ></el-table-column>
          <el-table-column
            property="businessNo"
            :formatter="emptyFn"
            label="业务编号"
          ></el-table-column>
          <el-table-column
            property="zfzt"
            :formatter="emptyFn"
            label="支付状态"
          ></el-table-column>
          <el-table-column
            property="res"
            :formatter="emptyFn"
            label="备注"
          ></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="zfztMark = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 订单详情 -->
    <orderDetail
      :rowData="row"
      v-if="orderDetilFlag"
      @destroy="destroy"
    ></orderDetail>
    <!-- 线下支付 -->
    <offlinePayment
      :rowData="row"
      v-if="offlineFlag"
      @destroy="destroy"
    ></offlinePayment>
  </div>
</template>

<script>
import { getBtn, getAttributeA } from '@/utils/getButton'
import {
  emptyFn,
  dateTimeFormat,
  encryption,
  toFixed,
  accMul
} from '@/utils/util'
import orderDetail from '@/views/consignment/payCustomer/settlement/orderDetail.vue'
import offlinePayment from '@/views/consignment/payCustomer/settlement/offlinePayment.vue'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import {
  upToPayDetail, // 余额
  settlementList, // 列表
  upstreamsettlementDetailList, // 应付合计
  tModifyPriceRecordList, // 调价记录
  upstreamSettlementPric, // 调价
  shipperPayment1, // 支付
  authenticationPwd // 验证支付密码
} from '@/api/consignment'
import { dictionaryList } from '@/api/soc-customer'
import { chaKanHuiDan } from '@/utils/chaKanHuiDan'
import { duration } from 'moment'
export default {
  components: {
    orderDetail,
    offlinePayment
  },
  data () {
    return {
      flago: false,
      toFixed: toFixed,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      accMul: accMul,
      h: '500px',
      // 查询调价
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        orderStatusList: '[1301]'
      },
      tableList: [],
      loading: false,
      total: 0,
      // 订单详情
      orderDetilFlag: false,
      row: {},
      // 付款
      fukuanMark: false,
      fukuanFrom: {
        ext1: 0,
        accountMoney: 0,
        departmentMoney: 0,
        isUrgentPaymentZ: false
      },
      // 调价
      tiaojiaMark: false,
      tiaojiaFrom: {},
      jjfangshi: [
        { val: 1, name: '单价' },
        { val: 2, name: '包干' }
      ],
      jiluMark: false,
      jiluList: [],
      unitMeasurement: '',
      // 合计
      HJmark: false,
      hejiList: [],
      rules: {
        pricingMethod: {
          required: true,
          message: '请选择计价方式',
          trigger: 'blur'
        },
        unitPrice: { required: true, message: '请输入单价', trigger: 'blur' },
        reason: { required: true, message: '请输入调价原因', trigger: 'blur' },
        password: { required: true, message: '请输入密码', trigger: 'blur' }
      },
      isDisable: false,
      MXlist: [],
      zfztList: [], // 支付状态列表
      zfztMark: false,
      offlineFlag: false, // 线下支付
      btnFlg: [],
      btnIdArr: [
        '00JP009B001',
        '00JP009B002',
        '00JP009B003',
        '00JP009B004',
        '00JM0D0100'
      ],
      isUrgent: null, // 是否加急支付 0否 1是
      customTypes: []
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/payCustomer/settlement')
    this.getList(this.searchFrom)
    this.getAttributeA()
    this.dictionaryList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 92 + 'px'
  },
  methods: {
    dictionaryList () {
      dictionaryList({
        groupName: 'pay_customs'
      }).then((res) => {
        this.customTypes = res
      })
    },
    getAttributeA () {
      getAttributeA(
        'ARRexpeditedPayment',
        localStorage.getItem('tenantCode')
      ).then((res) => {
        // console.log(res, '123')
        this.isUrgent = res[0]
        // 0 是 1否
        console.log(this.isUrgent, 'this.isUrgent')
      })
    },
    // 修改单元格样式的方法
    myclass ({ row, column, rowIndex, columnIndex }) {
      if (column.label == '付款状态') {
        if (row.isOverdue == '1') {
          return 'setclass'
        }
      }
    },
    // 线下支付
    xianxiaFn (row) {
      this.row = row
      this.row.flag = 1 // 代表是货主端
      this.offlineFlag = true
    },
    // 银行回单
    huidanFn (row) {
      chaKanHuiDan(row.businessNo, '', 2)
      // checkBankReceipt({ orderNo: row.businessNo }).then(res => {
      //   let url = this.global.ZXpingzheng + 'subAccNo=' + res.platformZxAccNo + '&printVerifyCode=' + res.printVerifyCode
      //   console.log(url)
      //   window.open(url)
      // }).catch(error => {
      //   this.$message({
      //     showClose: true,
      //     message: error.message,
      //     type: 'error',
      //     onClose () {
      //     }
      //   })
      // })
    },
    // 导出
    exportFn () {
      let form = this.searchFrom
      exportExcel(
        this.global.payServer + '/upstreamSettlement/exportFreightList',
        form,
        '运费支付列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 记录
    jiluFn (row) {
      this.jiluMark = true
      this.unitMeasurement = row.unitMeasurement
      tModifyPriceRecordList({ settlementId: row.id, settlementType: 1 }).then(
        (res) => {
          this.jiluList = res
          res.forEach((item, index) => {
            this.jiluList[index].tableList = [item]
          })
        }
      )
    },
    // 调价
    tiaojiaFn (row) {
      this.tiaojiaFrom = { ...row }
      this.tiaojiaMark = true
    },
    TJsave () {
      this.$refs.tiaojiaFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          upstreamSettlementPric({
            id: this.tiaojiaFrom.id,
            reason: this.tiaojiaFrom.reason,
            pricingMethod: this.tiaojiaFrom.pricingMethod,
            unitPrice: this.tiaojiaFrom.unitPrice
          })
            .then((res) => {
              loading.close()
              this.$message({
                message: '成功',
                type: 'success'
              })
              this.tiaojiaMark = false
              this.getList(this.searchFrom)
            })
            .catch((error) => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
        }
      })
    },
    // 付款
    fukuanFn () {
      const selectData = this.$refs.table.selection
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else if (selectData.length > 25) {
        this.$alert('最多只能选择25条数据进行操作', '系统提示')
      } else {
        this.ids = []
        this.businessNos = []
        let obj = new Map()
        for (let index = 0; index < selectData.length; index++) {
          const item = selectData[index]
          if (item.settlementStatus != 1301) {
            //
            this.$alert('该状态下的数据不能进行付款', '系统提示')
            return
          } else {
            if (index === 0) {
              obj.set(item.orgName, 1)
              this.ids.push(item.id)
              this.businessNos.push(item.businessNo)
            } else {
              if (obj.has(item.orgName)) {
                this.ids.push(item.id)
                this.businessNos.push(item.businessNo)
              } else {
                this.$alert('发布部门不相同数据不能批量进行付款', '系统提示')
                return
              }
            }
          }
        }
        this.fukuanFrom.settlementAccountId = selectData[0].settlementAccountId
        this.fukuanFrom.ids = this.ids.toString()
        upToPayDetail({ ids: this.fukuanFrom.ids })
          .then((res) => {
            this.fukuanFrom.ext1 = res.ext1
            this.fukuanFrom.accountMoney = res.accountMoney
            this.fukuanFrom.departmentMoney = res.departmentMoney
            this.fukuanMark = true
            if (this.isUrgent == '0') {
              this.$set(this.fukuanFrom, 'isUrgentPayment', 1)
            } else {
              this.$set(this.fukuanFrom, 'isUrgentPayment', '')
            }
            console.log(
              this.fukuanFrom.isUrgentPayment,
              'this.fukuanFrom.isUrgentPayment'
            )
          })
          .catch((error) => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error'
            })
          })
      }
    },
    ZFsave () {
      if (this.fukuanFrom.ext1 > this.fukuanFrom.accountMoney) {
        this.$confirm('账户余额不足请充值?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.$router.push({ path: '/payCustomer/recharge' })
          })
          .catch(() => {})
      } else {
        // if (this.fukuanFrom.isUrgentPaymentZ == false) {
        //   this.$set(this.fukuanFrom, 'isUrgentPayment', '')
        // } else {
        //   this.$set(this.fukuanFrom, 'isUrgentPayment', 1)
        // }

        this.$refs.fukuanFrom.validate((valid) => {
          if (valid) {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            this.zfztList = []
            let data = encryption({
              data: {
                id: this.fukuanFrom.settlementAccountId,
                password: this.fukuanFrom.password
              },
              key: this.global.key,
              param: ['password']
            })
            authenticationPwd(data)
              .then((res) => {
                this.digui(loading)
              })
              .catch((error) => {
                this.$message({
                  showClose: true,
                  message: error.message,
                  type: 'error',
                  onClose () {
                    loading.close()
                  }
                })
              })
          }
        })
      }
    },
    async digui (loading) {
      let _this = this
      try {
        const res = await shipperPayment1({
          ids: this.ids.join(','),
          isUrgentPayment: this.fukuanFrom.isUrgentPayment
        })

        console.log(res, 'res')
        console.log(res.code, 'gghfdghfjghfjh') // 确保这行执行

        if (res.code == 0) {
          if (Array.isArray(res.data) && res.data.length > 0) {
            res.data.forEach((item, index) => {
              yewu(index, item.orderNo, item.status, item.message)
            })
          }
        } else {
          loading.close()
          this.$message({
            showClose: true,
            message: res.message,
            type: 'error',
            duration: 3000
          })
        }
        // await shipperPayment1({
        //   ids: this.ids.join(','),
        //   isUrgentPayment: this.fukuanFrom.isUrgentPayment
        // })
        //   .then((res) => {
        //     console.log(res, 'res')
        //     if (res.code == 0) {
        //       if (Array.isArray(res.data) && res.data.length > 0) {
        //       // 遍历 ids 方法
        //         res.data.forEach((item, index) => {
        //           yewu(index, item.orderNo, item.status, item.message)
        //         })
        //       }
        //     } else {
        //       console.log(res.code, 'gghfdghfjghfjh')
        //       loading.close()
        //       this.$message({
        //         showClose: true,
        //         message: res.message,
        //         type: 'error'
        //       })
        //     }

        //     // else {
        //     //   this.ids.forEach((id, index) => {
        //     //     yewu(index, '支付失败', res.message)
        //     //   })
        //     // }
        //   })
      } catch (error) {
        console.log(error, 'error')
        // this.ids.forEach((item, index) => {
        //   yewu(index, item.orderNo, item.status, error.message)
        // })
        loading.close()
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error'
        })
      }

      function yewu (i, orderNo, zfzt, msg) {
        _this.zfztList.push({
          id: _this.ids[i],
          businessNo: orderNo,
          zfzt: zfzt,
          res: msg
        })
        if (i == _this.ids.length - 1) {
          loading.close()
          _this.fukuanMark = false
          _this.zfztMark = true
          _this.getList(_this.searchFrom)
        }
      }
      // return
      // for (let i = 0; i < this.ids.length; i++) {
      //   try {
      //     await shipperPayment({ ids: this.ids[i], isUrgentPayment: this.fukuanFrom.isUrgentPayment })
      //     yewu(i, '支付成功', '-')
      //   } catch (err) {
      //     yewu(i, '支付失败', err.message)
      //   }
      // }
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.zfzt == '支付成功') {
        return 'chenggong'
      } else {
        return 'shibai'
      }
    },
    // 应付合计
    YFHJfn (row) {
      this.HJmark = true
      upstreamsettlementDetailList({ businessNo: row.businessNo }).then(
        (res) => {
          this.hejiList = res.list
          this.row.totalAmount = row.totalAmount
        }
      )
    },

    // 订单详情
    seeClickNO (row) {
      if (row.invoiceType == 2 || row.invoiceType == '2') {
        return
      }
      this.row = row
      this.orderDetilFlag = true
    },
    destroy () {
      this.orderDetilFlag = false
      this.offlineFlag = false
    },
    // 查选
    searchFn () {
      if (this.searchFrom.businessNoss) {
        this.searchFrom.businessNos = this.searchFrom.businessNoss.split(
          /[(\r\n)\r\n]+/
        )
      } else {
        this.searchFrom.businessNos = ''
      }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      this.weight = 0.0
      selection.forEach((item) => {
        this.weight += item.weight
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      settlementList(searchFrom).then((res) => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    billDetails (row) {
      this.$router.push({ name: 'billDetails', query: { billId: row.id } })
    },

    // 重置
    resetForm (formName) {
      // debugger
      // this.$refs[formName].resetFields()
      // this.searchFrom.createTime=null
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        updateTimes: null
      }
    },
    closeDialog () {
      if (this.$refs['fukuanFrom']) {
        this.$refs['fukuanFrom'].clearValidate()
      }

      this.addForm = {}
      this.CHFrom = {}
      this.fukuanFrom = {
        accountMoney: 0,
        ext1: 0,
        departmentMoney: 0,
        isUrgentPaymentZ: false
      }
    }
  },
  watch: {
    tiaojiaFrom: {
      handler (newName, oldName) {
        // this.$set(this.tiaojiaFrom, 'weight', newName.weight)
        // this.$set(this.tiaojiaFrom, 'unitMeasurement', newName.unitMeasurement)
        if (this.tiaojiaFrom.pricingMethod == 1) {
          if (this.tiaojiaFrom.weight && this.tiaojiaFrom.unitPrice) {
            this.tiaojiaFrom.fatePrice = this.toFixed(
              accMul(this.tiaojiaFrom.weight, this.tiaojiaFrom.unitPrice),
              2
            )
            this.tiaojiaFrom.taxation = this.toFixed(
              (this.tiaojiaFrom.fatePrice / (1 - this.tiaojiaFrom.rate)) *
                this.tiaojiaFrom.rate,
              2
            )
            // this.tiaojiaFrom.taxation = this.toFixed(accMul(this.tiaojiaFrom.rate, this.tiaojiaFrom.fatePrice), 2)
          } else {
            this.$set(this.tiaojiaFrom, 'fatePrice', 0)
          }
        } else if (this.tiaojiaFrom.pricingMethod == 2) {
          if (this.tiaojiaFrom.unitPrice) {
            this.tiaojiaFrom.fatePrice = this.tiaojiaFrom.unitPrice
            this.tiaojiaFrom.taxation = this.toFixed(
              (this.tiaojiaFrom.fatePrice / (1 - this.tiaojiaFrom.rate)) *
                this.tiaojiaFrom.rate,
              2
            )
            // this.tiaojiaFrom.taxation = this.toFixed(accMul(this.tiaojiaFrom.rate, this.tiaojiaFrom.fatePrice), 2)
          }
        }

        function accMul (arg1, arg2) {
          var m = 0
          var s1 = arg1.toString()
          var s2 = arg2.toString()
          try {
            m += s1.split('.')[1].length
          } catch (e) {}
          try {
            m += s2.split('.')[1].length
          } catch (e) {}

          return (
            (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) /
            Math.pow(10, m)
          )
        }
      },
      deep: true
      // immediate: true
    }
  }
}
</script>

<style scoped lang="less">
.inpBox .el-date-editor {
  width: 350px !important;
}
/deep/.el-form-item {
  flex-shrink: 0;
}
/deep/.fanwei {
  display: flex;
  .el-form-item__content {
    display: flex;
  }
  .el-input__inner {
    width: 100px;
  }
}
/deep/.el-table .chenggong {
  background: #9bd67e !important;
}
/deep/.el-table .shibai {
  background: #f59191 !important;
}
/deep/.setclass {
  background: #f2e0d7;
}
</style>
